


























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  parseLocaleNumber,
  formatLocaleNumber,
} from "@/components/numbers/numberFormatUtils";

@Component
export default class NumericInput extends Vue {
  @Prop() value?: number | null;

  // behavior properties
  // empty field return type
  @Prop({ default: "null" }) emptyReturn?: "null" | "undefined" | "";
  // number of decimal places to show, min and max
  @Prop({ default: 2 }) decimalPlaces?: number | [number, number];
  // controls if value should be returned rounded to the nearest integer
  @Prop({ default: false }) valueAsInteger?: boolean;
  // controls if the value should be transformed to positive or negative
  @Prop({ default: "none" }) transform?: "none" | "toPositive" | "toNegative";

  // display/design properties
  @Prop() label?: string;
  @Prop({ default: true }) outlined?: boolean;
  @Prop() dense?: boolean;
  @Prop() disabled?: boolean;
  @Prop({ default: false }) readonly?: boolean;
  @Prop({ default: false }) hideDetails?: boolean;
  @Prop({ default: null }) suffix?: string;
  @Prop({ default: null }) prefix?: string;
  @Prop({ default: false }) reverse?: boolean;
  @Prop({ default: null }) placeholder?: string;

  // validation
  @Prop({ default: () => [] }) rules?: any[];

  @Getter("language/language") language?: string;

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  internalModel = "";

  isValid = false;

  @Watch("value", { immediate: true })
  inputValueChanged(fresh: number | null | undefined) {
    const forComparison = formatLocaleNumber(
      parseLocaleNumber(this.internalModel, this.internalLanguage),
      6,
      this.internalLanguage
    );

    const negativeZeroCheck = formatLocaleNumber(-0, 6, this.internalLanguage);
    const freshFormated = formatLocaleNumber(fresh, 6, this.internalLanguage);

    if (
      (freshFormated === forComparison && fresh !== 0) ||
      freshFormated === negativeZeroCheck
    ) {
      return;
    }

    if (Number.isNaN(fresh) || fresh == null || fresh == undefined) {
      this.internalModel = "";
    } else {
      this.internalModel = formatLocaleNumber(
        fresh,
        this.decimalPlaces,
        this.internalLanguage
      );
    }
  }

  //(#6177)Behaviour before:
  //1.user presses '-' -> only '-' renders, mouseClick outside the field -> '0.00' renders
  //2.user presses '+' -> '0.00' renders immidiately
  //Behaviour after adding "|| this.internalModel === '+'" to if clause
  //1.same as above
  //2.user presses '+' -> only '+' renders -> mouseClick outside the field -> '0.00' renders
  //if this emits '0' or '+0' instead of '-0' -> same as behaviour before 2.
  valueChanged() {
    if (this.internalModel === "-" || this.internalModel === "+") {
      this.$emit("input", -0);
    } else if (this.internalModel != "") {
      const n = parseLocaleNumber(this.internalModel, this.internalLanguage);

      // round to nearest integer if needed
      if (this.valueAsInteger) {
        this.$emit("input", Math.round(n));
      } else {
        this.$emit("input", n);
      }
    } else {
      this.$emit(
        "input",
        this.emptyReturn === "null"
          ? null
          : this.emptyReturn === "undefined"
          ? undefined
          : ""
      );
    }
  }

  format() {
    if (this.internalModel !== "" && !this.isValid) {
      // valid number check
      let n = parseLocaleNumber(this.internalModel, this.internalLanguage);

      // transform value as needed
      if (
        (n > 0 && this.transform === "toNegative") ||
        (n < 0 && this.transform === "toPositive")
      ) {
        n *= -1;
        this.$emit("input", n);
      }

      this.internalModel = formatLocaleNumber(
        n,
        this.decimalPlaces,
        this.internalLanguage
      );
    }

    this.$emit("blur");
  }
}
